import { ActionBarButton, ActionBarItemGroup } from "../core/action-bar/item";
import BarcodeAuthenticationModal from "./modals/barcode-authentication";

/** Button for logging out the currently authenticated user. */
export class BarcodeAuthenticationButton extends ActionBarButton {
    public title = 'Log out';
    public iconClassList = 'im im-barcode';
    public group = ActionBarItemGroup.RIGHT;

    public onClick(e: MouseEvent) {
        this.app.modals.show(new BarcodeAuthenticationModal());
    }

    public beforeRender(): PromiseLike<void> {
        this.title = this.app.pgettext('Title', 'Authentication');
        return super.beforeRender();
    }
}